import { render, staticRenderFns } from "./SubjectIntroduction.vue?vue&type=template&id=fa01cf72&scoped=true&"
import script from "./SubjectIntroduction.vue?vue&type=script&lang=js&"
export * from "./SubjectIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa01cf72",
  null
  
)

export default component.exports